import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { PLYWOOD_RAW_ORDER } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// 🔁 Lazy-load page components
const PlywoodInventoryList = lazy(() => import("app/pages/Inventory/Plywood/ListPlywood"));
const AddPlywoodStock = lazy(() => import("app/pages/Inventory/Plywood/AddPlywood"));
const EditPlywoodStock = lazy(() => import("app/pages/Inventory/Plywood/EditPlywood"));
const ViewDetails = lazy(() => import("app/pages/Inventory/Plywood/ListPlywood/Approval/ViewDetails"));
const IssueRawOrderPlywood = lazy(() => import("app/pages/Inventory/Plywood/IssueRawOrder"));

// ✅ Final route definition
export const plywoodInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "plywood_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/plywood",
        element: LoadablePage(PlywoodInventoryList),
      },
      {
        path: "/inventory/plywood/add",
        element: LoadablePage(AddPlywoodStock),
      },
      {
        path: "/inventory/plywood/edit",
        element: LoadablePage(EditPlywoodStock),
      },
      {
        path: "/inventory/plywood-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: PLYWOOD_RAW_ORDER,
        element: LoadablePage(IssueRawOrderPlywood),
      },
    ],
  },
];
